import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {selectUserSelf} from 'flows/session/selectors';

import {routeToDealInterestFromDeal as invest} from 'flows/routing';
import InvestorInvite from './component';

export class InvestorInviteContainer extends React.PureComponent {
  constructor() {
    super();
    this.invest = this.invest.bind(this);
  }
  invest() {
    const {deal, self} = this.props.invite;
    this.props.invest({
      deal,
      invite: {
        self,
      }
    });
  }
  render() {
    const {user, invite} = this.props;
    return (
      <InvestorInvite invite={invite} user={user} invest={this.invest} />
    );
  }
}

InvestorInviteContainer.propTypes = {
  invite: PropTypes.object.isRequired,
  user: PropTypes.string.isRequired,
  invest: PropTypes.func.isRequired
};

export const mapStore = store => ({
  user: selectUserSelf(store),
});

export default connect(mapStore, {invest})(InvestorInviteContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/investors/invited/components/InvestorInvite/index.js